import { baseRoutes } from "helpers/baseRoutes";

/**
 * Define access routes for authentication, specifying paths using baseRoutes from the "helpers/baseRoutes" module.
 * Each route has a unique identifier and a corresponding path.
 * @constant {Object} accessRoute
 */
const accessRoute = {
  LANDING: {
    path: `${baseRoutes.userBaseRoutes}`,
  },
  BLOGS: {
    path: `${baseRoutes.userBaseRoutes}/blog`,
  },
  BLOGS_DETAIL: {
    path: `${baseRoutes.userBaseRoutes}/blog/:slug`,
  },
  TERMS_AND_CONDITIONS: {
    path: `${baseRoutes.userBaseRoutes}/terms-and-conditions`,
  },
  PRIVACY_POLICY: {
    path: `${baseRoutes.userBaseRoutes}/privacy-policy`,
  },
  CANCELLATION_REFUND_POLICY: {
    path: `${baseRoutes.userBaseRoutes}/cancellation-and-refund-policy`,
  },
};

export default accessRoute;
